import { useQuery, useMutation, useQueryClient } from 'react-query';
import { predictionArbitrageManagerAxiosApi, predictionManagerAxiosApi } from 'src/Config/axiosApi';
import { PositionsGroupedByPair } from '../types';

interface PositionStats {
  total: number;
  open: number;
  closed: number;
  expired: number;
  totalInvested: number;
  totalUnrealizedPnl: number;
}

interface PositionsFilters {
  status?: string;
  platform?: string;
}

export function usePositionsGrouped(filters?: PositionsFilters) {
  return useQuery(
    ['positions-grouped', filters],
    async () => {
      const { data } = await predictionArbitrageManagerAxiosApi.get<
        PositionsGroupedByPair[]
      >('/positions/grouped', { params: filters });
      const groups = data.filter(g => g._id != null);
      const unmatched = data.filter(g => g._id == null);
      return { groups, unmatched };
    },
    { keepPreviousData: true }
  );
}

export function usePositionStats() {
  return useQuery(['position-stats'], async () => {
    const { data } =
      await predictionArbitrageManagerAxiosApi.get<PositionStats>(
        '/positions/stats'
      );
    return data;
  });
}

export function useUpdatePairThreshold() {
  const qc = useQueryClient();
  return useMutation(
    async ({ pairId, threshold }: { pairId: string; threshold: number }) => {
      const { data } = await predictionManagerAxiosApi.patch(
        `/pairs/${pairId}`,
        { maxInvestmentThreshold: threshold }
      );
      return data;
    },
    {
      onSuccess: () => {
        qc.invalidateQueries('positions-grouped');
      }
    }
  );
}

export function useSyncPositions() {
  const qc = useQueryClient();
  return useMutation(
    async () => {
      const { data } =
        await predictionArbitrageManagerAxiosApi.post('/positions/sync');
      return data;
    },
    {
      onSuccess: () => {
        qc.invalidateQueries('positions-grouped');
        qc.invalidateQueries('position-stats');
      }
    }
  );
}
